import React from "react";
import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "../mock";

const Testimonials = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-orange-50 to-[#fffaf3]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="text-amber-600 font-medium tracking-widest uppercase text-sm">
            Testimonials
          </span>
          <h2 className="font-display text-3xl sm:text-4xl text-orange-900 mt-2">
            What Our Pilgrims Say
          </h2>
          <div className="mx-auto mt-4 h-1 w-24 rounded-full bg-gradient-to-r from-amber-400 to-orange-600" />
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t) => (
            <div
              key={t.name}
              className="relative rounded-3xl bg-white p-7 shadow-md border border-amber-100 hover:shadow-xl transition-shadow"
            >
              <Quote className="h-9 w-9 text-amber-200 mb-3" />
              <p className="text-stone-600 leading-relaxed mb-5">“{t.text}”</p>
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <Star key={i} className="h-4 w-4 text-amber-400 fill-amber-400" />
                ))}
              </div>
              <div className="flex items-center gap-3">
                <div className="h-11 w-11 rounded-full bg-gradient-to-br from-amber-400 to-orange-600 flex items-center justify-center text-white font-display">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <div className="font-semibold text-stone-800 text-sm">
                    {t.name}
                  </div>
                  <div className="text-xs text-stone-500">{t.place}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
